'use strict';

/**
 * @author Maxim Seredkin
 */

import angular from 'angular';

export default ['$scope', '$uibModalInstance', 'land',
                function($scope, $modalInstance, land) {
                    $scope.ok = ok;
                    $scope.cancel = cancel;
                    $scope.isSelect = isSelect;

                    // инициализация
                    init();

                    // region Function

                    function init() {
                        $scope.land = angular.copy(land);
                    }

                    function ok(land) {
                        $modalInstance.close(land);
                    }

                    function cancel() {
                        $modalInstance.dismiss();
                    }

                    function isSelect() {
                        return ($scope.land != null && $scope.land.id != null) || !angular.equals($scope.land, {});
                    }

                    // endregion
                }];
